import React, { useState } from "react";
import "./logoutMobile.css";
import Typography from "antd/es/typography/Typography";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import TranslateText from "../../resuableComponents/TranslateText";
import {
  resetShopperInfo,
  selectMobileNumber,
} from "../../../slices/ShopperInfoSlice";
import { deleteCookie, generateDynamicLogo } from "../../../Utils/utils";
import {
  removeUpdatedShopperDetails,
  selectBaseColor,
} from "../../../slices/PaymentSessionDetailsSlice";
import ErrorModal from "../modals/errorModal/ErrorModal";
import { CloseCircleOutlined } from "@ant-design/icons";
import { selectSavedAddresses } from "../../../slices/SavedAddressSlice";
import { openAddressComponent } from "../../../slices/PaymentSessionDetailsSlice";
import {
  logoutModalOpenedEvent,
  logoutModalClosedEvent,
  logoutCompleteEvent,
} from "../../../Utils/uiAnalytics";

const LogoutMobile = () => {
  const { t } = useTranslation();
  const mobileNumber = useSelector((state) => selectMobileNumber(state));
  const baseColor = useSelector((state) => selectBaseColor(state));
  const [openLogoutModal, setOpenLogoutModal] = useState(false);
  const savedAddresses = useSelector((state) => selectSavedAddresses(state));
  const dispatch = useDispatch();
  const handleLogout = () => {
    logoutCompleteEvent();
    dispatch(resetShopperInfo());
    dispatch(openAddressComponent());
    dispatch(removeUpdatedShopperDetails());
    sessionStorage.removeItem("latestSaved");
    setOpenLogoutModal(false);

    // shopper token
    localStorage.removeItem("sessionToken");
    sessionStorage.removeItem("s_d");
    sessionStorage.removeItem("addressCollapse");
    localStorage.removeItem("isUserLoggedIn");
    deleteCookie("shopper_token")
  };

  const randomParamsForHmh = new URLSearchParams(document.location.search);
  const hmh = randomParamsForHmh.get("hmh");

  return (
    <div className="domestic-logout-root dynamic-font-styling">
      <ErrorModal
        icon={
          <CloseCircleOutlined style={{ color: "#FAAD14", fontSize: "22px" }} />
        }
        title={`${t("CONFIRM_LOGOUT")}?`}
        desc={`${t("SESSION_END_WARNING")}.`}
        showModal={openLogoutModal}
        primaryOnClick={() => handleLogout()}
        secondaryOnClick={() => {
          logoutModalClosedEvent();
          setOpenLogoutModal(false);
        }}
        primaryBtnText={t("YES_LOGOUT")}
        secondaryBtnText={t("NO")}
        showSecondaryButton={true}
      />
      {mobileNumber && (
        <Typography
          className="regular12Heading"
          style={{ color: "var(--Neutral-Grey-1000)" }}
        >
          <TranslateText label={"SHOWING_DETAILS_FOR"}>Showing details for </TranslateText>
          <span className="semiBold12Heading">{` ${mobileNumber}`}</span>
        </Typography>
      )}
      {
        !hmh && (
          <div
            className="domestic-mb-logout"
            onClick={() => {
              logoutModalOpenedEvent();
              setOpenLogoutModal(true);
            }}
          >
            {generateDynamicLogo("logout", "12px", "12px", baseColor)}
            <Typography className="dynamic-title semiBold12Heading">
              <TranslateText label={"LOGOUT"}>Logout</TranslateText>
            </Typography>
          </div>
        )
      }
    </div>
  );
};

export default LogoutMobile;
